export {};



// WEBPACK FOOTER //
// ./src/store/getters.js